import React from 'react';

const PenCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7979 2.66671C12.656 2.66671 12.5199 2.72308 12.4195 2.82344L7.16818 8.0748L6.91593 9.0838L7.92493 8.83155L13.1763 3.58018C13.2766 3.47983 13.333 3.34373 13.333 3.20181C13.333 3.05989 13.2766 2.92379 13.1763 2.82344C13.0759 2.72308 12.9398 2.66671 12.7979 2.66671ZM11.4767 1.88063C11.8271 1.53023 12.3024 1.33337 12.7979 1.33337C13.2935 1.33337 13.7687 1.53023 14.1191 1.88063C14.4695 2.23103 14.6664 2.70627 14.6664 3.20181C14.6664 3.69735 14.4695 4.17259 14.1191 4.52299L8.73717 9.90493C8.65173 9.99037 8.54468 10.051 8.42746 10.0803L6.16138 10.6468C5.9342 10.7036 5.69387 10.637 5.52828 10.4714C5.3627 10.3059 5.29613 10.0655 5.35293 9.83835L5.91945 7.57227C5.94875 7.45505 6.00936 7.348 6.0948 7.26256L11.4767 1.88063Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1953 3.52864C10.4556 3.26829 10.8777 3.26829 11.1381 3.52864L12.4714 4.86197C12.7318 5.12232 12.7318 5.54443 12.4714 5.80478C12.2111 6.06513 11.7889 6.06513 11.5286 5.80478L10.1953 4.47145C9.93491 4.2111 9.93491 3.78899 10.1953 3.52864Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99967 2.66671C5.05416 2.66671 2.66634 5.05452 2.66634 8.00004C2.66634 10.9456 5.05416 13.3334 7.99967 13.3334C10.9452 13.3334 13.333 10.9456 13.333 8.00004V7.66671C13.333 7.29852 13.6315 7.00004 13.9997 7.00004C14.3679 7.00004 14.6663 7.29852 14.6663 7.66671V8.00004C14.6663 11.6819 11.6816 14.6667 7.99967 14.6667C4.31778 14.6667 1.33301 11.6819 1.33301 8.00004C1.33301 4.31814 4.31778 1.33337 7.99967 1.33337H8.33301C8.7012 1.33337 8.99967 1.63185 8.99967 2.00004C8.99967 2.36823 8.7012 2.66671 8.33301 2.66671H7.99967Z"
      fill="currentColor"
    />
  </svg>
);
export default PenCircleIcon;
